import styled, { css } from 'styled-components/macro'

export const AnimationContainer = styled.div`
  position: absolute;
  overflow: hidden;
  aspect-ratio: 16/9;

  @media (max-width: 1024px) {
    aspect-ratio: 1024/1080;
  }
  @media (max-width: 520px) {
    aspect-ratio: 575/852;
  }

  min-height: 100%;
  min-width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;

  img {
    position: absolute;
  }
  .celek {
    left: 0;
    top: 0;
    width: 100%;
  }

  @keyframes blinking {
    0% {
      opacity: 1;
    }
    68% {
      opacity: 0;
    }
    70% {
      opacity: 1;
    }
    88% {
      opacity: 0;
    }
    90% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`
export const Background = styled.img`
  width: 100%;
  top: 0;
`
export const Screen1 = styled.img<{ $ani: boolean }>`
  left: 46.6%;
  top: 6%;
  width: 13.9%;
  @media (max-width: 1024px) {
    left: 30.5%;
    top: 6.2%;
    width: 26%;
  }
  @media (max-width: 520px) {
    left: 15.2%;
    top: 5.7%;
    width: 36.5%;
  }
  ${(props) =>
    props.$ani &&
    css`
      animation: blinking 1s steps(1, end) forwards;
      animation-delay: 0s;
      animation-iteration-count: 1;
    `}
`
export const Screen2 = styled.img<{ $ani: boolean }>`
  left: 2%;
  top: 7.2%;
  width: 13.4%;
  @media (max-width: 1024px) {
    left: 0%;
    top: 5.9%;
    width: 7.3%;
  }
  @media (max-width: 520px) {
    left: 52.5%;
    top: 10.6%;
    width: 27.6%;
  }
  ${(props) =>
    props.$ani &&
    css`
      animation: blinking 1s steps(1, end) forwards;
      animation-delay: 0.1s;
      animation-iteration-count: 1;
    `}
`
export const Screen3 = styled.img<{ $ani: boolean }>`
  left: 18.1%;
  top: 5.7%;
  width: 16.2%;
  @media (max-width: 1024px) {
    display: none;
  }
  ${(props) =>
    props.$ani &&
    css`
      animation: blinking 1s steps(1, end) forwards;
      animation-delay: 0.3s;
      animation-iteration-count: 1;
    `}
`
export const Screen4 = styled.img<{ $ani: boolean }>`
  left: 60.8%;
  top: 11%;
  width: 10.4%;
  @media (max-width: 1024px) {
    left: 57%;
    top: 11%;
    width: 19.6%;
  }
  @media (max-width: 520px) {
    display: none;
  }
  ${(props) =>
    props.$ani &&
    css`
      animation: blinking 1s steps(1, end) forwards;
      animation-delay: 0.5s;
      animation-iteration-count: 1;
    `}
`
export const Women = styled.img<{ $ani: boolean }>`
  left: 0%;
  width: 100%;
  top: 0%;
  opacity: 0;
  transition: opacity 1s;
  transition-delay: 1.3s;
  ${(props) =>
    props.$ani &&
    css`
      opacity: 1;
    `}
`
